import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { ArgumentInputProps } from './types';

export function ChoiceInput({ arg, onChange, isError }: ArgumentInputProps) {
  const hasError = isError && arg.is_required && !String(arg.value).trim();
  const options: string[] = arg.options ?? [];

  return (
    <Select
      value={String(arg.value || '')}
      onValueChange={(val) => onChange(val)}
    >
      <SelectTrigger className={`h-7 ${hasError ? 'border-destructive' : ''}`}>
        <SelectValue placeholder={arg.placeholder || 'Select option'} />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt} value={opt}>
            {opt}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
